import { render, staticRenderFns } from "./CityDialog.vue?vue&type=template&id=08ce12c4"
import script from "./CityDialog.vue?vue&type=script&lang=js"
export * from "./CityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports